import {DEFAULT_TEXT_FIELDS} from "~/constants/string";

export const KVT_TEXTS_LIST: Record<string, string> = Object.assign({
    HRESULT: "Результат:",
    HDATE_HTIME: "Дата та час формування запиту:",
}, DEFAULT_TEXT_FIELDS);
